const footer = {
    ru: {
        nav_1: "Главная",
        nav_2: "Услуги и портфолио",
        nav_3: "О нас",
        mail: "digital@aroundgroup.ru",
        tel: "+7 495 789 88 38"
    },

    eng: {
        nav_1: "Main page",
        nav_2: "Services & Cases",
        nav_3: "About us",
        mail: "digital@aroundgroup.ru",
        tel: "+7 495 789 88 38"
    },
    az: {
        nav_1: "Ana səhifə",
        nav_2: "Xidmətlər və nümunələr",
        nav_3: "Haqqımızda",
        mail: "sales@aroundgroupp.com",
        tel: "+9 (715) 237 613 94"
    }
}

export default footer